export const settingsTimeOptions = [
  // { value: '10', display: '10 minutes' },
  // { value: '1', display: '1 hour' },
  // { value: '2', display: '2 hours' },
  { value: 1, display: '24 hours' },
  { value: 7, display: '7 days' },
  { value: 30, display: '30 days' },
  { value: 90, display: '3 months' },
  { value: 180, display: '6 months' },
  { value: 360, display: '1 year' },
];